/* eslint-disable @typescript-eslint/no-explicit-any */
import {useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import React, {useEffect, useMemo, useState} from 'react';
import {View} from 'react-native';
import {connect} from 'react-redux';
import {ApiResponse} from '../../../../data/types/interface/api';
import {
  IData,
  IDataWs,
  IDisplay,
} from '../../../../data/types/interface/Contrats/souscriptionContrat';
import {StackParams} from '../../../../data/types/navigation';
import mapDispatchToProps from '../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../services/redux/mapStateToProps';
import {HeaderScreen} from '../../../components/Header/HeaderScreen';
import {Loader} from '../../../components/Loader';
import {ProduitItem} from '../../../components/ProduitItem';

type NavigationProps = StackNavigationProp<StackParams, 'SouscrireContrat'>;

interface Props {
  getCategorieTypeassurance: any;
}

export function SouscrireContratScreen(props: Props) {
  const {navigate} = useNavigation<NavigationProps>();
  const {getCategorieTypeassurance} = props;
  const [listItem, setListItem] = useState<Array<IDataWs>>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    setIsLoading(() => true);
    getCategorieTypeassurance({}, (res: ApiResponse) => {
      setListItem(
        res && res.data && res.data.items.length > 0
          ? res.data.items
          : undefined,
      );
      setIsLoading(() => false);
    });
  }, [getCategorieTypeassurance]);

  const aList: IData[] = useMemo(
    () => [
      {
        libelle: 'Famille',
        navigate: () => {
          navigate('FamilleContrat');
        },
        destinationPage: 'FamilleContrat',
        id: '',
        data: '',
      },
      {
        libelle: 'Epargne et prévoyance',
        navigate: () => {
          navigate('EpargneEtPrevoyanceContrat');
        },
        destinationPage: 'EpargneEtPrevoyanceContrat',
        id: '',
        data: '',
      },
    ],
    [],
  );

  const datas = useMemo(
    () =>
      listItem
        ? aList.map((elt, i) => {
            elt.libelle = listItem[i]?.nom || elt.libelle;
            elt.id = listItem[i]?.id || elt.id;
            elt.imageUrl = listItem[i]?.imageUrl || elt.imageUrl;
            return elt;
          })
        : [],
    [listItem, aList],
  );

  const display: IDisplay = {items: []};
  display.items = datas;

  return (
    <View style={{flex: 1}}>
      <HeaderScreen
        title="Compte > Souscrire un Contrat"
        type="GoToMonEspace"
        noBreadcrumb={false}
      />
      {isLoading ? <Loader /> : <ProduitItem data={display} />}
    </View>
  );
}
export const SouscrireContrat: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SouscrireContratScreen);
